/*
 * @Description:  
 * @Version: 1.0
 * @Author: tu
 * @Date: 2024-01-30 15:19:04
 * @LastEditors: tu
 * @LastEditTime: 2024-02-02 16:57:40
 * @FilePath: /clinic-home-web/src/views/outPatient/medicalRecord/static-data.js
 */

import { cityCode } from '@/utils/cityPicker/cityCode';
export const addMemberConfig = [
  {
    labelWidth: '100px', label: '姓名', key: 'name', type: 'input', prop: 'name',
    attrs: { placeholder: '请输入姓名', clearable: true, disabled: false, style: { width: '100%' } },
  },
  {
    labelWidth: '100px', label: '性别', key: 'gender', type: 'radio', prop: 'gender',
    attrs: { placeholder: '请输入姓名', clearable: true, disabled: false, style: { width: '100%' } },
    optionAttrs: { label: 'label', value: 'value', key: 'value' }
  },
  {
    labelWidth: '100px', label: '联系电话', key: 'phone', type: 'input', prop: 'phone',
    attrs: { placeholder: '请输入联系电话', clearable: true, disabled: false, style: { width: '100%' } },
  },
  {
    labelWidth: '100px', label: '生日', key: 'birthday', type: 'daterange',
    attrs: {
      placeholder: '请选择日期', clearable: true, disabled: false, style: { width: '100%' },
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now();
        },
      },
      format: 'yyyy-MM-dd', valueFormat: 'yyyy-MM-dd'
    },
  },
  {
    labelWidth: '100px', label: '身份证', key: 'idCard', type: 'input',
    attrs: { placeholder: '请输入身份证',   clearable: true, disabled: false, style: { width: '100%' } },
  },
  {
    labelWidth: '100px', label: '紧急联系人', key: 'emergencyMan', type: 'input',
    attrs: { placeholder: '请输入紧急联系人', clearable: true, disabled: false, style: { width: '100%' } },
  },
  {
    labelWidth: '100px', label: '紧急联系电话', key: 'emergencyContact', type: 'input',
    attrs: { placeholder: '请输入紧急联系电话', clearable: true, disabled: false, style: { width: '100%' } },
  },
  {
    labelWidth: '100px', label: '职业', key: 'profession', type: 'input',
    attrs: { placeholder: '请输入职业', clearable: true, disabled: false, style: { width: '100%' } },
  },
  {
    labelWidth: '100px', label: '地址', key: 'attr', type: 'cascader',
    attrs: { placeholder: '请选择地址', clearable: true, disabled: false, style: { width: '100%' }, options: cityCode },
  },
  {
    labelWidth: '100px', label: '详细地址', key: 'address', type: 'input',
    attrs: { placeholder: '请输入详细地址', clearable: true, disabled: false, style: { width: '100%' } },
  },
  {
    labelWidth: '100px', label: '备注', key: 'remark', type: 'input',
    attrs: { placeholder: '请输入备注', clearable: true, disabled: false, style: { width: '100%' } },
  }
]
export const popoverAttrs = {
  'popper-class': 'drug-info-search-popover-common',
  trigger: 'manual',
  width: '500',
};
export const selectAttrs = {
  status: [{ value: -1, label: '全部', }, { value: 1, label: '启用', }, { value: 2, label: '禁用', }],
  hiMapStas: [{ value: -1, label: '全部', }, { value: 0, label: '未匹配', }, { value: 1, label: '已匹配', }],
  gender: [{ value: 0, label: '女', }, { value: 1, label: '男', }],
}
export const addMemberFormAttrs = {
  ref: 'addMemberFormRef',
  rules: {
    name: { required: true, message: '请输入姓名', trigger: 'blur' },
    gender: { required: true, message: '请选择性别', trigger: 'change' },
    phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }, { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号', trigger: ['blur', 'change'] }],
  }
}
export const addMemberFormAttrsDelPhone = {
  ref: 'addMemberFormRef',
  rules: {
    name: { required: true, message: '请输入姓名', trigger: 'blur' },
    gender: { required: true, message: '请选择性别', trigger: 'change' },
  }
}